import { onMounted, onUnmounted } from 'vue';

/**
 * Scroll-reveal for public (.lp-page) pages — mirrors the landing page.
 * Adds the `reveal` class to common content elements, staggers siblings,
 * and toggles `in-view` as they enter/leave the viewport.
 */
const DEFAULT_SELECTORS = [
  '.lp-hero',
  '.lp-section-head',
  '.lp-card',
  '.stat',
  '.story-image',
  '.story-content',
  '.lp-cta',
  '.reveal-item',
];

export function useReveal(selectors = DEFAULT_SELECTORS) {
  let observer = null;

  onMounted(() => {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const els = [];
    selectors.forEach((sel) => {
      document.querySelectorAll('.lp-page ' + sel).forEach((el) => {
        if (!els.includes(el)) els.push(el);
      });
    });

    els.forEach((el) => el.classList.add('reveal'));
    // stagger siblings that reveal together (grids, stat rows)
    els.forEach((el) => {
      const parent = el.parentElement;
      if (!parent) return;
      const sibs = [...parent.children].filter((c) => c.classList.contains('reveal'));
      const i = sibs.indexOf(el);
      if (i > 0) el.style.transitionDelay = (Math.min(i, 5) * 0.08).toFixed(2) + 's';
    });

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => e.target.classList.toggle('in-view', e.isIntersecting));
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => observer.observe(el));
  });

  onUnmounted(() => {
    if (observer) observer.disconnect();
  });
}
